import React from 'react';
import PropTypes from 'prop-types';
import Card from "react-bootstrap/Card";

MyCard.defaultProps = {
    withClose: false,
}

MyCard.propTypes = {
    header: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    body: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    footer: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    variant: PropTypes.oneOf(['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'dark', 'light']),
    onClose: PropTypes.func,
};

function MyCard(props) {
    return (
        <Card>
            {props.header && <Card.Header
                className={`bg-${props.variant ? props.variant : "primary text-white"} `}>{props.header}
                {props.onClose && <button
                    onClick={props.onClose}
                    type="button"
                    className="close"
                    aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>}
            </Card.Header>}
            <Card.Body>
                {props.body}
            </Card.Body>
            {props.footer && <Card.Footer>{props.footer}</Card.Footer>}
        </Card>
    );
}

export default MyCard;